import { FC } from 'react';

import { H1Section } from 'bloko/blocks/header';
import VSpacing from 'bloko/blocks/vSpacing';

import { useSelector } from 'src/hooks/useSelector';
import { SearchCatalogListType } from 'src/models/searchCatalogList';

import ContentByLetter from 'src/pages/SearchCatalogList/components/Content/ByLetter';
import ContentMain from 'src/pages/SearchCatalogList/components/Content/Main';

interface ContentProps {
    header: string;
}

const Content: FC<ContentProps> = ({ header }) => {
    const searchCatalogList = useSelector((state) => state.searchCatalogList);

    if (!searchCatalogList) {
        return null;
    }

    return (
        <>
            <VSpacing base={14} xs={10} />
            <H1Section Element="h1">{header}</H1Section>
            <VSpacing base={10} xs={9} />
            {searchCatalogList.listType === SearchCatalogListType.Main ? (
                <ContentMain {...searchCatalogList} />
            ) : (
                <ContentByLetter {...searchCatalogList} />
            )}
            <VSpacing base={6} xs={5} />
        </>
    );
};

export default Content;
